import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { AM_TP_DEMO_ROUTES, TAmDemoClientOverviewResponse } from './types';

/**
 * The four figures on the client profile's stat row.
 *
 * A demo-specific read because the product's own stat row derives all four from connected-ERP transaction data
 * and renders zeroes when there is none.
 */
export function useAmTpDemoClientOverview(
  companyId: number | null,
  fiscalYear?: number
) {
  const baseUrl = `${AM_TP_DEMO_ROUTES.clientOverview}?companyId=${companyId}${
    fiscalYear === undefined ? '' : `&fiscalYear=${fiscalYear}`
  }`;

  const {
    data,
    error,
    mutate,
  }: {
    data?: TAmDemoClientOverviewResponse;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    companyId ? baseUrl : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
    isLoading: !data && !error,
  };
}
